<form class="drop-padding" (ngSubmit)="add()">
  <mat-form-field>
    <mat-label>Ключ для поиска</mat-label>
    <input matInput type="text" [formControl]="keyControl" placeholder="Ключ для поиска" />
  </mat-form-field>
  <button mat-flat-button color="primary" type="submit">Добавить</button>
</form>
